import React from "react";
import { Col, Container, Nav, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTelegram } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons"
import PropTypes from "prop-types";

import './FooterStyle.css'


const sociaIcons = [
	{
		icon: faTelegram,
		href: "https://t.me/ScholarizeGroup",
	},
		{
		icon: faEnvelope,
		href: "mailto:scholarize.contact@gmail.com", 
	},

];


const NavigationItem = ({ item }) => (
	<Nav.Item>
		<Nav.Link href={item.href}>{item.value}</Nav.Link>
	</Nav.Item>
);

NavigationItem.propTypes = {
	item: PropTypes.object.isRequired,
};

const SocialItem = ({ social }) => (
	<li>
		<a
			href={social.href}
			className="d-flex justify-content-center align-items-center rounded-circle"
		>
			<FontAwesomeIcon icon={social.icon} size="4x"/>
		</a>

	</li>
);

SocialItem.propTypes = {
	social: PropTypes.object.isRequired,
};

const Footer = () => {
	return (
		<div className="ezy__footer4 light">
			<Container>
				<Row className="d-flex justify-content-between align-items-center text-center text-lg-start">
					<Col xs={12} className="text-center">
						<h2 className="fw-bold fa-3x mb-0"
						 style={{'font-family': 'fantasy',
						  
						  }}>
							SCHOLARIZE
						</h2>
						{/* <Nav className="ezy__footer4-nav justify-content-center my-4 my-lg-5"> */}
						<Nav className="ezy__footer4-social justify-content-center my-4 my-lg-5">
							{sociaIcons.map((social, i) => (
								<SocialItem social={social} key={i} />
							))}
						</Nav>
						{/* </Nav> */}
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<p className="mb-0 mt-1">
							Copyright &copy;Scholarize.org, All rights reserved
						</p>
					</Col>

				</Row>
			</Container>
		</div>
	);
};

export default Footer